const ContentBottom = ({ children, fixed = false }) => {
  let contentClass = 'content-botton container'
  if(fixed) contentClass += ' fixed' 

  return (
    <div className={contentClass}>
      <div className='row justify-content-center'>
        <div className='col-12'>{children}</div>
      </div>
    </div>
  );
};

export default ContentBottom;
